const mode = 'cors'
const headers = {
  'access-token': process.env.ACCESS_TOKEN,
  Accept: `application/vnd.${process.env.APP_NAME}.api+json;version=v${process.env.API_VERSION}`,
}

export const get = (endpoint) => {
  return fetch(`${process.env.API_DOMAIN}/${endpoint}`, {
    mode,
    headers,
  })
}

export const post = (endpoint, data = {}) => {
  const body = new FormData()

  Object.keys(data).forEach((key) => {
    body.append(key, data[key])
  })

  return fetch(`${process.env.API_DOMAIN}/${endpoint}`, {
    mode,
    headers,
    body,
    method: 'POST',
  })
}



// WEBPACK FOOTER //
// ./src/util/request.js